import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';
import { TypeRelationshipRecord } from '@/lib/api/accountManager/types';

export type CreateChildRelationshipParams = {
  userUuid: string | undefined;
  childName: string;
  childBirthDate: string;
  authToken?: string;
};

export async function createChildRelationship(
  params: CreateChildRelationshipParams,
) {
  const { userUuid, childName, childBirthDate, authToken } = params;

  if (!userUuid || !childName || !childBirthDate) {
    console.warn('[createChildRelationship]: Missing Required Params');
  }

  const config = {
    method: 'POST',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      relationship: {
        relationship_type: 'unknown',
        child: {
          name: childName.trim(),
          birthday: childBirthDate,
        },
      },
    }),
  };

  const response = await fetch(
    `${API_URLS.ACCOUNT_MANAGER_PROXY}/users/${userUuid}/relationships`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypeRelationshipRecord>;
}
